// Material Paginator API
// https://material.angular.io/components/paginator/api
export const CM_MAT_PAGINATOR_DEFAULT_OPTIONS = {
  pageIndex: 1,
  pageSize: 20,
  length: 0,
  showFirstLastButtons: true,
};
